module.exports = __webpack_public_path__ + "fonts/Anjoman-FaNum-LightItalic.5b6e444.woff2";